import dayjs from "dayjs";
import subDays from "date-fns/subDays";

export type PresetType =
  | "weekly"
  | "monthly"
  | "yearly"
  | "dailyInMonth"
  | "custom";

  export const getSubtitle = (data: any[], mode: PresetType): string => {
  if (!Array.isArray(data) || data.length === 0) return "";

  const safeDate = (input: any) =>
    input && dayjs(input).isValid() ? dayjs(input) : null;

  if (mode === "weekly" || mode === "custom") {
    const validDates = data
      .map((d) => 
        safeDate(d.day_date || d.date || d.day) 
      )
      .filter(Boolean) as dayjs.Dayjs[];

    if (validDates.length === 0) return "";
    
    validDates.sort((a, b) => a.valueOf() - b.valueOf());

    return `${validDates[0].format("MMM D, YYYY")} → ${validDates.at(-1)!.format(
      "MMM D, YYYY"
    )}`;
  }

  if (mode === "monthly") {
    const date = safeDate(data[0]?.week_start_date);
    return date ? date.format("MMMM YYYY") : "";
  }

  if (mode === "dailyInMonth") {
    const date = safeDate(data[0]?.day || data[0]?.date);
    return date ? date.format("MMM D, YYYY") : "";
  }

  if (mode === "yearly") {
    const years = Array.from(
      new Set(
        data
          .map((d) => safeDate(d.month_date))
          .filter(Boolean)
          .map((d) => d!.year())
      )
    );
    return years.join(", ");
  }

  return "";
};

export const getDefaultRange = (
  preset: PresetType
): [Date | null, Date | null] => {
  const today = new Date();
  if (preset === "weekly") return [subDays(today, 6), today];
  if (preset === "monthly")
    return [
      new Date(today.getFullYear(), today.getMonth(), 1),
      new Date(today.getFullYear(), today.getMonth() + 1, 0),
    ];
  return [null, null];
};

export const isDefaultWeek = (range: [Date | null, Date | null]) => {
  if (!range[0] || !range[1]) return false;
  const today = new Date();
  return (
    range[0].toDateString() === subDays(today, 6).toDateString() &&
    range[1].toDateString() === today.toDateString()
  );
};

export const isDefaultMonth = (range: [Date | null, Date | null]) => {
  if (!range[0] || !range[1]) return false;
  const today = new Date();
  const first = new Date(today.getFullYear(), today.getMonth(), 1);
  const last = new Date(today.getFullYear(), today.getMonth() + 1, 0);
  return (
    range[0].toDateString() === first.toDateString() &&
    range[1].toDateString() === last.toDateString()
  );
};
